import React from 'react';
import { Box } from '@material-ui/core';

const LOGO_SIZE = 48;

interface IOrganizationLogoProps {
  logoUrl?: string;
  organizationName: string;
}

// Logo with a text-initials fallback so the layout doesn't shift between
// associations that have uploaded a logo and those that haven't.
export const OrganizationLogo: React.FC<IOrganizationLogoProps> = ({ logoUrl, organizationName }) => {
  const baseStyle: React.CSSProperties = {
    width: LOGO_SIZE,
    height: LOGO_SIZE,
    borderRadius: '50%',
    flexShrink: 0,
    objectFit: 'contain',
    background: '#f3f4f6',
    border: '1px solid #e5e7eb',
  };

  if (logoUrl) {
    return <img src={logoUrl} alt="" style={baseStyle} />;
  }

  const initial = (organizationName || '?').trim().charAt(0).toUpperCase();
  return (
    <Box
      style={{
        ...baseStyle,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#374151',
        fontWeight: 600,
        fontSize: 18,
      }}
      aria-hidden="true"
    >
      {initial}
    </Box>
  );
};
